import React, { useMemo } from "react";
import BrandHeader from "../BrandHeader";
import AppNav from "../AppNav";
import "./Customer.css";

const HOME = "/components/customer/CustomerDashboard";

const PAGES = [
    { label: "Order", to: HOME },
    // { label: "Order Generic", to: "/components/customer/OrderGeneric" },
    { label: "Order Upload", to: "/OrderUpload/" },
    { label: "Order by Comp", to: "/components/customer/OrderByComp_Customer" },
    // moved here off the public home page
    { label: "Product List", to: "/ProductList" },
    { label: "New Products", to: "/New_Product" },
];

const REPORTS = [
    { label: "View Ledger", to: "/components/customer/Ledger" },
    { label: "Pending Bills", to: "/components/customer/PendingBills" },
    { label: "Download Invoice", to: "/components/customer/DownLoadInvoice" },
    { label: "Payment Receipts", to: "/components/customer/PaymentReceipts" },
    { label: "Order List", to: "/components/customer/OrderList" },
    { label: "Bounce List", to: "/components/customer/BounceList" },
    { label: "Bill Tracking", to: "/components/customer/BillTracking" },
];

// after Reports - bank details & payment QR, customer-only
const AFTER = [
    { label: "Account Info", to: "/components/customer/AccountInfo" },
];

export default function HeaderCustomer() {
    const userInfo = useMemo(
        () =>
            localStorage.getItem("user-info")
                ? JSON.parse(localStorage.getItem("user-info"))
                : null,
        []
    );

    function logout() {
        window.localStorage.removeItem("user-info");
        window.localStorage.removeItem("user-id");
        window.localStorage.removeItem("app-type");
        window.localStorage.removeItem("report-firm");
        window.location.href = "/Customer";
    }

    return (
        <>
            {/* the logo and the name go to the public landing page */}
            <BrandHeader to="/" />

            <AppNav
                items={PAGES}
                menus={[{ label: "Reports", items: REPORTS }]}
                itemsAfter={AFTER}
                trailing={
                    <>
                        {userInfo ? (
                            <span className='custUser'>
                                <span className='custUserName'>{userInfo.name}</span>
                                {userInfo.place ? (
                                    <span className='custUserPlace'>{userInfo.place}</span>
                                ) : null}
                            </span>
                        ) : null}
                        <button type="button" className='custLogout' onClick={logout}>
                            Log Out
                        </button>
                    </>
                }
            />
        </>
    );
}
